/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { RouteLocationNormalizedLoadedGeneric } from '#vue-router'

function toAppRouteLog(route: RouteLocationNormalizedLoadedGeneric | None): gen.AppLogsInputLogRoute | undefined {
  if (!route || !('fullPath' in route)) return
  const res: gen.AppLogsInputLogRoute = { name: myLinkName(route), fullPath: route.fullPath }
  if (route.path?.length) res.path = route.path
  if (route.query && typeof route.query === 'object') res.query = Object.entries(route.query).map(([key, value]) => ({ key, value: Array.isArray(value) ? value.join(',') : value }))
  return res
}
const log = (label: string, ...rest: unknown[]) => console.log(`%c → ${label.padStart(9, ' ')}`, `background: #ffb7b7; color: #fff; border-radius: 1px`, ...rest)

export function useAnalytics() {
  const state = useState('useAnalytics:queue', () => shallowRef({ q: [] as gen.AppLogsInputLog[], at: undefined as undefined | number }))
  const timer = useTimeoutGlobal('useAnalytics')
  const fast = useFast()
  const auth = useAuth()
  const to = useRuntimeConfig().public.backendLogs
  const route = useRoute()
  const mobile = useMobile()

  function sendIt() {
    if (!auth.value.userId) return
    timer.clear()
    if (!state.value.q.length) return
    const input: gen.AppLogsInput = { log: [...state.value.q] }
    state.value = { q: [], at: undefined }
    if (fast.value) log('logs:send ', input)
    if (!to) return
    if (navigator.sendBeacon) navigator.sendBeacon(to, new Blob([JSON.stringify(input)], { type: 'application/json' }))
    else $fetch(to, { method: 'POST', body: input, keepalive: true }).catch((err) => console.warn('[analytics:error:sendIt]', err))
  }

  function track(inpCb: (inp: { toAppRouteLog: typeof toAppRouteLog }) => gen.AppLogsInputLog | None) {
    const inp = helpers.tryCatch(() => inpCb({ toAppRouteLog }))
    if (fast.value) log('logs:add ', inp)
    if (!helpers.isDef(inp)) return
    const now = new Date().getTime()
    const at = state.value.at || now
    if (!inp.to) inp.to = toAppRouteLog(route)
    if (!inp.m) inp.m = mobile.value
    if (!inp.time) inp.time = new Date().toISOString()
    state.value = { q: [...helpers.arr(state.value.q), inp], at }
    if (inp.action === 'Exit') sendIt()
    else if (inp.action === 'Enter' || (at && now - at > 1000 * 15)) timer.set(() => sendIt(), 3000)
  }

  return { track }
}
